import React, { useMemo } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import CreateReportPage from './CreateReportPage';
import FileUploadStep from '../components/report/FileUploadStep';
import AnalyticsStep from '../components/report/AnalyticsStep';
import ProcessingStep from '../components/report/ProcessingStep';

const StepReportPage: React.FC = () => {
  const { step } = useParams<{ step: string }>();
  
  // Мемоизируем компонент шага
  const StepComponent = useMemo(() => {
    switch (step) {
      case 'upload':
        return <FileUploadStep />;
      case 'analytics':
        return <AnalyticsStep />;
      case 'processing':
        return <ProcessingStep />;
      default:
        return <Navigate to="/create-report/upload" replace />;
    }
  }, [step]);
  
  return (
    <CreateReportPage isStepPage={true}>
      {StepComponent}
    </CreateReportPage>
  );
};

export default StepReportPage;
